<template>
    <v-dialog v-model="editPermissionsDialog" max-width="767" persistent>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="setPermissions()" :color="successColor" icon>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Edit</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Edit Permissions
            </v-card-title>
            <v-card-text>
                <v-form ref="editPermissionsForm" v-model="valid" lazy-validation>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" md="3">
                                Applicants/Forms
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminapplicants.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminapplicants.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminapplicants.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminApplicantsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Residents
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminresidents.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminresidents.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminresidents.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminResidentsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Notifications
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminnotifications.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminnotifications.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminnotifications.access"
                                    :items="notificationItems" label="Notification Type" placeholder="Please select..."
                                    :rules="adminNotificationsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Permissions
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminpermissions.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminpermissions.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminpermissions.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminPermissionsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Reports
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminreports.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminreports.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminreports.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminReportsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Residence Assistant Manager
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox
                                    v-model="currentPermissions.permissions.adminresidenceassistantmanager.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminresidenceassistantmanager.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminresidenceassistantmanager.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminResidenceAssistantManagerRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Statistics
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminstatistics.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminstatistics.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminstatistics.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminStatisticsRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                Pairing &amp; Placement
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminroommatematcher.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminroommatematcher.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminroommatematcher.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminMatcherRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                System Configuration
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-checkbox v-model="currentPermissions.permissions.adminsystemconfiguration.enabled"
                                    false-value="0" hide-details
                                    :label="currentPermissions.permissions.adminsystemconfiguration.enabled == '1' ? 'Enabled' : 'Disabled'"
                                    true-value="1">
                                </v-checkbox>
                                <v-select v-model="currentPermissions.permissions.adminsystemconfiguration.access"
                                    :items="permissionItems" label="Permission Type" placeholder="Please select..."
                                    :rules="adminSystemConfigurationRules" required>
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn ref="confirmBtn" class="white--text" :color="successColor" :disabled="!valid"
                    @click="editPermissions()">
                    Save
                </v-btn>
                <v-btn :color="warningColor" @click="closeDialog()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'permissions-edit',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            adminApplicantsRules: [
                v => !!v || 'Applicant/Forms permission type is required',
            ],
            adminResidentsRules: [
                v => !!v || 'Residents permission type is required',
            ],
            adminNotificationsRules: [
                v => !!v || 'Notification type is required',
            ],
            adminPermissionsRules: [
                v => !!v || 'Permissions permission type is required',
            ],
            adminReportsRules: [
                v => !!v || 'Reports permission type is required',
            ],
            adminResidenceAssistantManagerRules: [
                v => !!v || 'Residence Assistant Manager permission type is required',
            ],
            adminStatisticsRules: [
                v => !!v || 'Statistics permission type is required',
            ],
            adminMatcherRules: [
                v => !!v || 'Pairing&Placement permission type is required',
            ],
            adminSystemConfigurationRules: [
                v => !!v || 'System Configuration permission type is required',
            ],
            currentPermissions: {
                permissions: {
                    adminapplicants: {
                        access: '',
                        enabled: ''
                    },
                    adminresidents: {
                        access: '',
                        enabled: ''
                    },
                    adminnotifications: {
                        access: '',
                        enabled: ''
                    },
                    adminpermissions: {
                        access: '',
                        enabled: ''
                    },
                    adminreports: {
                        access: '',
                        enabled: ''
                    },
                    adminresidenceassistantmanager: {
                        access: '',
                        enabled: ''
                    },
                    adminstatistics: {
                        access: '',
                        enabled: ''
                    },
                    adminroommatematcher: {
                        access: '',
                        enabled: ''
                    },
                    adminsystemconfiguration: {
                        access: '',
                        enabled: ''
                    }
                }
            },
            editPermissionsDialog: false,
            notificationItems: [
                {
                    text: 'All',
                    value: 'all'
                },
                {
                    text: 'Applications',
                    value: 'applications'
                },
                {
                    text: 'Credit Card Payments',
                    value: 'creditCardPayments'
                }
            ],
            permissions: [
                'adminapplicants',
                'adminresidents',
                'adminnotifications',
                'adminpermissions',
                'adminreports',
                'adminresidenceassistantmanager',
                'adminstatistics',
                'adminroommatematcher',
                'adminsystemconfiguration'
            ],
            permissionItems: [{
                    text: 'Read-Only',
                    value: 'read'
                },
                {
                    text: 'Full Access',
                    value: 'write'
                }
            ],
            valid: true
        }
    },
    methods: {
        closeDialog() {
            this.editPermissionsDialog = false;
        },
        editPermissions() {
            if (this.$refs.editPermissionsForm.validate()) {
                this.updatePermissions(this.currentPermissions);
            }
        },
        setPermissions() {
            let user = JSON.parse(JSON.stringify(this.item));

            // Resolve user permissions
            this.permissions.forEach(permission => {
                if (user.permissions[permission]) {
                    this.currentPermissions.permissions[permission] = user.permissions[permission];
                }
            });

            // Set user
            user.permissions = this.currentPermissions.permissions;
            this.currentPermissions = user;

            if (this.$refs.editPermissionsForm) {
                this.$refs.editPermissionsForm.resetValidation();
            }
        },
        updatePermissions(item) {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl`;
            let user = item;

            // Loading
            this.$refs.confirmBtn.loading = true;

            // Parse array into string
            formData.append('mode', 'setPermissions');
            formData.append('user', JSON.stringify(user));

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-account-edit', `Permissions for ${user.cn} has been successfully updated.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-alert-circle', `Permissions for ${user.cn} could not be updated. ${json.message}.`, true);
                    }

                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeDialog();
                })
                .catch(function () {
                    that.$emit('refreshData');
                    that.$refs.confirmBtn.loading = false;
                    that.closeDialog();
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        primaryColor() {
            return '#5867dd';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0;
}
</style>